import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo Client - 客戶上傳身分證正面文件 (含OCR換補領資訊)
 */
const UploadIdFrontFile = [
    'POST',
    RouteUrlList.API_ClientUploadIdFrontFile.path,
    {},
    200,
    {
        status: true,
        code: 0,
        exception: null,
        message: '身分證正面檔案已成功上傳，並完成 OCR 辨識',
        result: {
            documentIdList: ['7c85f64-8829-4562-b3fc-2c963f66afa9'],
            documentIdFirstOrDefault: '7c85f64-8829-4562-b3fc-2c963f66afa9',
            fileHash: '5a6b7c8d9e0f1a2b3c4d5e6f7a8b9c0d1e2f3a4b5c6d7e8f9a0b1c2d3e4f5a6b',
            mimeType: 'image/jpeg'
        }
    }
];

export default UploadIdFrontFile;
